export default "__VITE_ASSET__BCDKhGmn__"